/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Locked_OnInputs */



/**
* | output |
* | --- |
* | "Locked On" |
*
* @param {Explorer_Info_Property_Locked_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_locked_on = /** @type {((inputs?: Explorer_Info_Property_Locked_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Locked_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouille le")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingesperrt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bloccato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заблокировано")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("锁定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロックオン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस दिन लॉक किया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Travado em")
	return /** @type {LocalizedString} */ ("Locked On")
});